import { type ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export interface CheckFieldProps {
    name: string;
    label: ReactNode;
    disabled?: boolean;
}

export function CheckField({ name, label, disabled }: CheckFieldProps) {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const { t } = useTranslation();
    const error = errors[name];
    const message = typeof error?.message === 'string' ? t(error.message) : undefined;
    const errorId = `${name}-error`;

    return (
        <Form.Group className="mb-3" controlId={name}>
            <Form.Check
                type="checkbox"
                label={label}
                disabled={disabled}
                isInvalid={!!error}
                aria-describedby={error ? errorId : undefined}
                {...register(name)}
            />
            {message && (
                <div className="invalid-feedback d-block" id={errorId}>
                    {message}
                </div>
            )}
        </Form.Group>
    );
}
